import { Mail, MapPin, Phone } from "lucide-react";
import { Page } from "@/components/Page";
import { EnquiryForm } from "@/components/EnquiryForm";
import { Eyebrow, FadeUp } from "@/components/Reveal";

const DETAILS = [
  { icon: Mail, label: "Correspondence", value: "concierge@mdsarabama.com", href: "mailto:concierge@mdsarabama.com", testId: "contact-email" },
  { icon: Phone, label: "Direct line", value: "+44 7481 952461", href: "tel:+447481952461", testId: "contact-phone" },
  { icon: MapPin, label: "Mayfair desk", value: "12 Mount Street, London W1", href: null, testId: "contact-address" },
];

export default function Contact() {
  return (
    <Page testId="contact-page">
      <section className="mx-auto max-w-[1280px] px-6 pb-28 pt-40 lg:px-12 lg:pt-48">
        <div className="grid gap-16 lg:grid-cols-[1fr_1.4fr] lg:gap-24">
          <div>
            <FadeUp>
              <Eyebrow>Contact</Eyebrow>
            </FadeUp>
            <FadeUp delay={0.1}>
              <h1 className="mt-6 font-serif text-4xl font-medium leading-[1.08] text-ivory sm:text-5xl">
                Begin the <span className="gold-text italic">conversation.</span>
              </h1>
            </FadeUp>
            <FadeUp delay={0.2}>
              <p className="mt-6 max-w-sm text-sm font-light leading-relaxed text-ivory-muted">
                Every enquiry is read and answered personally by a senior member
                of our team — usually within the hour.
              </p>
            </FadeUp>
            <div className="mt-12 space-y-8">
              {DETAILS.map((d, i) => (
                <FadeUp key={d.label} delay={0.25 + i * 0.08}>
                  <div className="flex items-start gap-5">
                    <d.icon className="mt-1 h-4 w-4 text-champagne" strokeWidth={1.25} />
                    <div>
                      <p className="text-[10px] font-medium uppercase tracking-[0.3em] text-champagne/70">
                        {d.label}
                      </p>
                      {d.href ? (
                        <a
                          href={d.href}
                          data-testid={d.testId}
                          className="mt-2 block font-serif text-xl font-light text-ivory transition-colors duration-300 hover:text-champagne"
                        >
                          {d.value}
                        </a>
                      ) : (
                        <p data-testid={d.testId} className="mt-2 font-serif text-xl font-light text-ivory">
                          {d.value}
                        </p>
                      )}
                    </div>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>
          <FadeUp delay={0.2}>
            <div className="border border-[rgba(200,164,93,0.22)] bg-noir-soft p-7 sm:p-10">
              <EnquiryForm initialService="Concierge" idPrefix="contact" />
            </div>
          </FadeUp>
        </div>
      </section>
    </Page>
  );
}
